app.controller("EditSeasonWeekController", [
    "$scope", "Season", "$uibModalInstance", "params", "toastr",
    function ($scope, Season, $uibModalInstance, params, toastr) {
        $scope.weekNumber = params.weekNumber;
        $scope.startDate = new Date(params.startDate);
        $scope.endDate = new Date(params.endDate);

        $scope.popup1 = {
          opened: false
        };
        $scope.popup2 = {
          opened: false
        };

        $scope.openStartDate = function () {
          $scope.popup1.opened = true;
        };

        $scope.openEndDate = function () {
          $scope.popup2.opened = true;
        };

        $scope.onStartDateChange= function () {
          $scope.endDate = moment($scope.startDate)
            .add(6, 'days') // endDate included in week.
            .toDate();
        };

        $scope.edit = function () {
            Season.editWeek({
                seasonId: params.seasonId,
                weekNumber: params.weekNumber,
                startDate: $scope.startDate,
                endDate: $scope.endDate
            }).then(function () {
                $uibModalInstance.close();
            }).catch(function (err) {
              if (err.status !== 400) {
                throw err;
              }

              var errorsMap = {
                'startDate must not be greater than endDate': 'კვირის დაწყების თარიღი დამთავრების თარიღზე მეტი არ უნდა იყოს',
                'week dates intersect with other week dates': 'მითითებულ კვირას სხვა კვირებთან საერთო დღეები არ უნდა ჰქონდეს'
              };

              var geoMessage = errorsMap[err.data];

              if (geoMessage) {
                toastr.warning('', geoMessage, {timeOut: 6000});
              } else {
                throw err;
              }
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

    }
]);
